<template>
    <div class="post_row">
        <div class="post_block">
            <div class="post_block_inner flex">
                <div class="right_content">
                    <div class="post_title">
                        {{ post.title }}
                    </div>
                    <div v-if="post.subtitle" class="sub_title">
                        {{ post.subtitle }}
                    </div>
                    <div class="image_wrapper">
                        <div class="block_image">
                            <picture v-full-image-path="post.featuredImage" />
                        </div>
                    </div>
                </div>
                <div class="main_content">
                    <div class="content_wrapper">
                        <div class="content">
                            <h3>{{ descriptionLabel }}</h3>

                            <div v-html="post.description" />

                            <content-builder
                                v-if="mainContent.length"
                                :value="mainContent"
                            />
                        </div>
                    </div>

                    <div
                        v-if="additionalDescription.length"
                        class="additional_description"
                    >
                        <content-builder
                            class="description_list flex"
                            :value="additionalDescription"
                        />
                    </div>
                </div>
                <div class="btn_wrapper">
                    <button
                        class="btn btn_template"
                        @click="$emit('apply', post)"
                    >
                        {{ buttonText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContentBuilder from '@/components/boards/content-builder';

export default {
    components: {
        ContentBuilder
    },

    props: {
        post: {
            type: Object,
            required: true
        },

        buttonText: {
            type: String,
            required: true
        },

        descriptionLabel: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            mainContentTypes: ['long', 'wysiwyg']
        };
    },

    computed: {
        mainContent() {
            return this.post.content.filter(item =>
                this.mainContentTypes.includes(item.type)
            );
        },

        additionalDescription() {
            return this.post.content.filter(
                item => !this.mainContentTypes.includes(item.type)
            );
        }
    }
};
</script>
